import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

export interface SelectDropdownOption {
  value: string;
  label: string;
}

export interface SelectDropdownProps {
  value: string;
  label: string;
  options: SelectDropdownOption[];
  onChange: (value: string) => void;
  minWidth?: number | string;
  sx?: SxProps<Theme>;
}

export const SelectDropdown = ({
  value,
  label,
  options,
  onChange,
  minWidth = 120,
  sx,
}: SelectDropdownProps) => (
  <FormControl size="small" sx={{ minWidth, ...sx }}>
    <InputLabel>{label}</InputLabel>
    <Select value={value} label={label} onChange={(e) => onChange(e.target.value)}>
      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
